import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../../component/Api";
import "../../Assets/student/studentlogin.css";
import logo from "../../Assets/img/logo-small.png";

const Login = () => {
  const navigate = useNavigate();
  const { http } = Api();

  localStorage.removeItem("token");

  const [isRedirecting, setIsRedirecting] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 500);

  // --- NEW STATE FOR ACCOUNT SELECTION ---
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [accountList, setAccountList] = useState([]);
  // ---------------------------------------

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 500);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //login
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [islogin, setislogin] = useState(true);
  const [validationLoginMessage, setValidationLoginMessage] = useState("");
  const [error, setloginerror] = useState("");

  //registration
  const [apaarNo, setApaar] = useState("");
  const [AadharNo, setAadharNo] = useState("");
  const [dob, setDate] = useState("");
  const [validationRegMessage, setValidationRegMessage] = useState("");
  const [error1, setRegerror] = useState("");
  const [success, setSuccess] = useState("");

  const validateForm = () => {
    const setErrors = {};
    if (!apaarNo && !AadharNo && !dob) {
      setErrors.general = "*Please enter all required fields";
    } else {
      if (!apaarNo) setErrors.apaarNo = "*ApaarNo No. required";
      else if (!/^\d{12}$/.test(apaarNo))
        setErrors.apaarNo1 = "*Apaar No. number must be 12 digits";

      if (!AadharNo) setErrors.AadharNo = "*Aadhar No. required";
      else if (!/^\d{12}$/.test(AadharNo))
        setErrors.AadharNo1 = "*Aadhaar No. must be 12 digits";

      if (!dob) setErrors.dob = "*Date of birth";
    }
    setValidationRegMessage(setErrors);
    return Object.keys(setErrors).length === 0;
  };

  //register
  const handleRegister = (e) => {
    e.preventDefault();
    setValidationRegMessage("");
    setSuccess("");

    if (validateForm()) {
      setIsRedirecting(true);
      http
        .post("/validateEmailAndSendmail", {
          apaar_no: apaarNo,
          aadhar: AadharNo,
          dob: dob,
        })
        .then((response) => {
          if (response.data.status_code === "MSG11") {
            setSuccess(response.data.message);
            setRegerror("");
          } else {
            setRegerror(response.data.message);
          }
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.message || "An error occurred";
          setRegerror(errorMessage);
        })
        .finally(() => {
          setIsRedirecting(false);
        });
    }
  };

  // --- REFACTORED LOGIN LOGIC ---

  // Helper to process successful login
  // Helper to process successful login
  const processLoginSuccess = (data) => {
    // 1. Save Token
    localStorage.setItem("token", data.token);

    // ---------------------------------------------------------
    // ⚡ CRITICAL FIX: Force Axios to use the new token IMMEDIATELY
    // This prevents the "401" error when the Dashboard tries to load
    // ---------------------------------------------------------
    if (http.defaults) {
      http.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    }

    // 2. Handle Details Storage
    const details = Array.isArray(data.student_details)
      ? data.student_details[0]
      : data.student_details;

    localStorage.setItem("pathway_id", details.pathway_id);
    localStorage.setItem("student_details", JSON.stringify(data.student_details));

    // 3. NAVIGATION LOGIC (The Change You Requested)
    if (data.login_action === 'readmission') {
      // Backend says this user is inactive but eligible for readmission
      // Redirect to your specific readmission page/route
      navigate("/studentreadmission");
    } else {
      // Default: Go to dashboard
      navigate("/studentdashboard");
    }
  };

  // 1. Initial Login Request
  const handleLogin = (e) => {
    e.preventDefault();

    if (!username && !password) {
      setValidationLoginMessage("*Username and Password are required.");
      setloginerror({ userpass: "true" });
      return;
    }
    if (!username) {
      setValidationLoginMessage("*Username is required.");
      setloginerror({ user: "true" });
      return;
    }
    if (!password) {
      setValidationLoginMessage("*Password is required.");
      setloginerror({ pass: "true" });
      return;
    }

    // Call API
    performLoginRequest(username, password, null);
  };

  // 2. The Actual API Call Function
  const performLoginRequest = (uid, pass, selectedAccountId = null) => {

    // Construct payload dynamically to be clean
    const payload = {
      user_id: uid,
      password: pass
    };

    // Only attach the ID if the user actually picked one
    if (selectedAccountId) {
      payload.selected_account_id = selectedAccountId;
    }

    http
      .post("/studentlogin", payload)
      .then((Result) => {
        // CHECK FOR MULTIPLE ACCOUNTS
        if (Result.data.status === "multiple_accounts") {
          setAccountList(Result.data.accounts);
          setShowAccountModal(true); // Open the popup
          return; // Stop execution here
        }

        // Normal Login Success
        if (Result.data.token) {
          processLoginSuccess(Result.data);
        } else {
          // Fallback if token is missing (shouldn't happen with success status)
          setValidationLoginMessage(Result.data.message || "Login failed");
        }
      })
      .catch((error) => {
        // Only navigate away if it's not a handled selection error
        if (!showAccountModal) {
          // navigate('/');
        }

        // Handle specific 403 errors (like "Access Restricted")
        const msg = error.response?.data?.message || "Invalid Credentials";
        setValidationLoginMessage(msg);
      });

    setloginerror("");
    setValidationLoginMessage("");
  };

  // 3. Handle User Selection from Modal
  const handleFinalLogin = (accountId) => {
    // Call login again, but this time with the specific Account ID
    performLoginRequest(username, password, accountId);
  };

  // -----------------------------

  const toggleShowPassword = () => setShowPassword(!showPassword);
  const switchToLogin = () => setislogin(true);
  const switchToSignup = () => setislogin(false);

  return (
    <>
      {/* --- SELECTION MODAL START --- */}
      {showAccountModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h4 style={{ marginBottom: "15px", color: "#333" }}>
              Select Profile
            </h4>
            <p style={{ fontSize: "14px", color: "#666" }}>
              Multiple accounts found for this APAAR ID.
            </p>

            <div style={styles.listContainer}>
              {accountList.map((acc, index) => (
                <div
                  key={index}
                  onClick={() => handleFinalLogin(acc.accountid)}
                  style={styles.accountCard}
                >
                  <div style={{ fontWeight: "bold" }}>
                    {acc.discipline_name || "Application ID: " + acc.accountid}
                  </div>
                  <div style={{ fontSize: "12px", marginTop: "5px" }}>
                    Status:
                    <span
                      style={{
                        color: acc.status === "active" ? "green" : "red",
                        fontWeight: "bold",
                        marginLeft: "5px",
                      }}
                    >
                      {acc.status ? acc.status.toUpperCase() : "UNKNOWN"}
                    </span>
                  </div>
                  <div style={{ fontSize: "11px", color: "#888" }}>
                    College ID: {acc.collegeid}
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => setShowAccountModal(false)}
              style={styles.cancelButton}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      {/* --- SELECTION MODAL END --- */}

      {isRedirecting ? (
        <div className="body23">
          <div className="container23">
            <div
              className="login-box23"
              style={{ minHeight: "50%", alignContent: "center" }}
            >
              <div className="card-body d-flex justify-content-center align-items-center">
                <div className="containeranimate">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="body23">
          <div className="container23">
            <div className="login-box23">
              <div className="circle23">
                <img
                  className="img-fluid for-light"
                  src={logo}
                  alt="MGU Logo"
                />
              </div>

              {islogin ? (
                <>
                  <div className="heading12">Sign in to Your Account</div>
                  <form onSubmit={handleLogin}>
                    <div>
                      <input
                        type="number"
                        className={`input-field23 ${error.user || error.userpass ? "error12" : ""
                          }`}
                        placeholder="APAAR No."
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                      <div className="password-wrapper">
                        <input
                          type={showPassword ? "text" : "password"}
                          className={`input-field23 ${error.pass || error.userpass ? "error12" : ""
                            }`}
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                          className="password-toggle e-icon"
                          onClick={toggleShowPassword}
                        >
                          <i
                            className={`fa ${showPassword
                              ? "fa-eye fa-stl"
                              : "fa-eye-slash fa-stl"
                              }`}
                          />
                        </span>
                      </div>
                      {validationLoginMessage && (
                        <span className="validation-message">
                          {validationLoginMessage}
                        </span>
                      )}

                      <div className="st-lgn-pdg1">
                        <a
                          href="#/studentinstructions"
                          className="forgot-password23"
                        >
                          Student Instructions
                        </a>
                      </div>
                      <div className="st-lgn-pdg1">
                        <a
                          href="#/studentforgetpassword"
                          className="forgot-password23"
                        >
                          Forgot Password..?
                        </a>
                      </div>
                    </div>
                    <div className="form-group23">
                      <label className="remember-label23">
                        <a
                          href="#"
                          className="forgot-password23"
                          onClick={switchToSignup}
                        >
                          Don't have an account? Sign up
                        </a>
                      </label>
                    </div>
                    {/* <marquee
                      behavior="scroll"
                      direction="left"
                      scrollamount="4"
                    >
                      <strong className="text-danger">
                        e-Copy application deadline for III Semester MGU UGP
                        (Honours) /BBA (Honours) /BCA (Honours) Examination
                        October 2025 is 24.12.2025.
                      </strong>
                    </marquee> */}

                  
                        <marquee behavior="scroll" direction="left" scrollamount="4">
                          <div>
                            <strong className="text-danger">
                              e-Copy application deadline for First Semester MGU-UGP (Honours)/BBA (Honours) /BCA (Honours)
                              Regular/Supplementary/Betterment Examination November 2025 is 06/01/2026.
                            </strong>
                          </div>
                          <div>
                            <strong className="text-danger">
                              e-Copy application deadline for First Semester MGU-B.Voc (Honours)
                              Regular Examination November 2025 is 08/01/2026.
                            </strong>
                          </div>

                           <div>
                            <strong style={{ color: 'green'}}>
                            First Semester MGU-B.Voc (Honours)
                              Regular Examination November 2025 results are published.
                            </strong>
                          </div>
                        </marquee>

                    <button type="submit" className="submit-btn23">
                      Login
                    </button>
                  </form>
                </>
              ) : (
                <>
                  <div className="heading12">Register Your Account</div>
                  <form onSubmit={handleRegister}>
                    {/* ... (Existing Registration Form code unchanged) ... */}
                    <div>
                      <input
                        type="text"
                        className={`input-field23 ${validationRegMessage.apaarNo ? "error12" : ""
                          }`}
                        placeholder="APAAR No. *"
                        value={apaarNo}
                        maxLength={12}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            setApaar(value);
                          }
                        }}
                        pattern="\d*"
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        className={`input-field23 ${validationRegMessage.AadharNo ||
                          validationRegMessage.AadharNo1
                          ? "error12"
                          : ""
                          }`}
                        placeholder="Aadhar No. *"
                        value={AadharNo}
                        maxLength={12}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            setAadharNo(value);
                          }
                        }}
                        pattern="\d*"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="apaarNo"
                        className="form-label text-start w-90"
                      >
                        Date of Birth
                        <span className="text-danger"> &nbsp;*</span>
                      </label>
                      <input
                        type="date"
                        className={`input-field23 ${validationRegMessage.dob ? "error12" : ""
                          }`}
                        value={dob}
                        onChange={(e) => setDate(e.target.value)}
                      />
                      {validationRegMessage.general && (
                        <span className="validation-message">
                          {validationRegMessage.general}
                        </span>
                      )}
                      {validationRegMessage.apaarNo && (
                        <span className="validation-message">
                          {validationRegMessage.apaarNo}
                        </span>
                      )}
                      {validationRegMessage.apaarNo1 && (
                        <span className="validation-message">
                          {validationRegMessage.apaarNo1}
                        </span>
                      )}
                      {validationRegMessage.AadharNo && (
                        <span className="validation-message">
                          {validationRegMessage.AadharNo}
                        </span>
                      )}
                      {validationRegMessage.AadharNo1 && (
                        <span className="validation-message">
                          {validationRegMessage.AadharNo1}
                        </span>
                      )}
                      {validationRegMessage.dob && (
                        <span className="validation-message">
                          {validationRegMessage.dob}
                        </span>
                      )}
                      {error1 && (
                        <span className="validation-message">{error1}</span>
                      )}
                      {success && (
                        <span className="success-message">{success}</span>
                      )}
                    </div>
                    <div className="form-group23">
                      <label className="remember-label23">
                        <a
                          href="#"
                          className="forgot-password23"
                          onClick={switchToLogin}
                        >
                          Already have an account? Login
                        </a>
                      </label>
                    </div>
                    <button type="submit" className="submit-btn23">
                      Signup
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Simple inline styles for the Modal
// (You can move these to studentlogin.css if you prefer)
const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    width: "90%",
    maxWidth: "400px",
    textAlign: "center",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  },
  listContainer: {
    maxHeight: "300px",
    overflowY: "auto",
    marginBottom: "15px",
  },
  accountCard: {
    border: "1px solid #ddd",
    borderRadius: "5px",
    padding: "10px",
    marginBottom: "10px",
    cursor: "pointer",
    textAlign: "left",
    backgroundColor: "#f9f9f9",
    transition: "0.2s",
  },
  cancelButton: {
    background: "none",
    border: "none",
    color: "#d9534f",
    cursor: "pointer",
    textDecoration: "underline",
  },
};

export default Login;
